import React from "react";
import image from "../Assets/fond5.jpg";

function Echo() {
  return (
    <div className={`wrapSectionPage`}>
      <div className="entetePage fond5">
        <div className="textItem">
          <h1>Echo</h1>
        </div>
      </div>
      <div className="rowText">
        <div className="gauche image">
          <img src={image} alt="description" />
        </div>
        <div className="droite texte">
          <h2>Détails à venir bientôt!</h2>
        </div>
      </div>
    </div>
  );
}

export default Echo;
